import defaultsDeep from 'lodash/defaultsDeep'
import actionTypes from 'constants/actionTypes'

interface UserState {
  id: string
  username: string
  isFetching: boolean
  updated: number | null
  [key: string]: unknown
}

interface UserInput {
  id?: string
  username?: string
  index?: number
  [key: string]: unknown
}

interface UserAction {
  type?: string
}

const initialState: UserState = {
  id: '',
  username: '',
  isFetching: false,
  updated: null,
}

export default (state: UserState = initialState, action: UserAction, user: UserInput): UserState => {
  switch (action.type) {
    case actionTypes.USERS.GET.REQUEST:
      return defaultsDeep(
        {
          isFetching: true
        },
        user,
        state
      )
    case actionTypes.USERS.GET.RECEIVE:
      return defaultsDeep(
        {
          isFetching: false,
          updated: Date.now()
        },
        user,
        state
      )
    case actionTypes.USERS.GET.FAIL:
      return defaultsDeep(
        {
          isFetching: false
        },
        state
      )
    case actionTypes.PERMISSIONS.NEW_CONTENT.READERS.ADD:
    case actionTypes.PERMISSIONS.NEW_CONTENT.WRITERS.ADD:
    case actionTypes.PERMISSIONS.NEW_CONTENT.SET:
      return defaultsDeep(
        {
          updated: Date.now()
        },
        user,
        state
      )
  }
  return state
}
